const LS_REFERRAL_CODE = "referral_code";

export const REFERRAL_CODE_MIN = 4;
export const REFERRAL_CODE_MAX = 16;

/**
 * Catch the `ref` query param on any route, persist it to localStorage
 * (so it survives redirects and the Google OAuth round-trip) and strip
 * it from the URL. Must run before the router mounts, otherwise a
 * redirect (e.g. ProtectedLayout → /sign-in) can drop the param first.
 */
export function captureReferralCode(): void {
	const url = new URL(window.location.href);
	const ref = url.searchParams.get("ref");
	if (ref === null) return;

	const code = ref.trim();
	if (
		code.length >= REFERRAL_CODE_MIN &&
		code.length <= REFERRAL_CODE_MAX
	) {
		localStorage.setItem(LS_REFERRAL_CODE, code);
	}

	url.searchParams.delete("ref");
	window.history.replaceState(window.history.state, "", url.toString());
}

export function getSavedReferralCode(): string | null {
	return localStorage.getItem(LS_REFERRAL_CODE);
}

export function clearReferralCode(): void {
	localStorage.removeItem(LS_REFERRAL_CODE);
}
